import React from 'react';
import arrowL from '@/assets/image/title-arrow-l.png';
import arrowR from '@/assets/image/title-arrow-r.png';

import styles from './index.less';


interface ITitleProps {
  title: string;
}
const Title: React.FC<ITitleProps> = ({ title }) => {
  return (
    <div className={styles.title}>
      <img src={arrowL} alt="" />
      <span>{title}</span>
      <img src={arrowR} alt="" />
    </div>
  );
};

export default Title;
